import { FETCH_RANKING } from '../constants/ranking';

export function fetchRanking(rankType) {
  return {
    type: FETCH_RANKING,
    api: true,
    auth: true,
    payload: {
      method: 'GET',
      url: rankType ? `/students/ranking/${rankType}` : '/students/ranking'
    }
  };
}
